import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/98f710363dd775f147ae7b4e3b05b287.jpg" 
              alt="Liver Insight Platform" 
              className="h-12 w-12 object-contain"
            />
            <span className="text-xl font-bold text-navy">Liver Insight Platform</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer">
              ホーム
            </Link>
            <Link to="/fib4-calculator" className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer">
              肝臓検査ツール
            </Link>
            <a href="#about" className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer">
              プラットフォーム
            </a>
            <a href="#contact" className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer">
              お問い合わせ
            </a>
            <button className="px-6 py-2.5 bg-aqua text-white font-semibold rounded-lg hover:bg-aqua-light transition-colors whitespace-nowrap cursor-pointer">
              無料デモ
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col gap-4">
              <Link 
                to="/" 
                className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                ホーム
              </Link>
              <Link 
                to="/fib4-calculator" 
                className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                肝臓検査ツール
              </Link>
              <a 
                href="#about" 
                className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                プラットフォーム
              </a>
              <a 
                href="#contact" 
                className="text-gray-700 hover:text-aqua transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                お問い合わせ
              </a>
              <button className="px-6 py-2.5 bg-aqua text-white font-semibold rounded-lg hover:bg-aqua-light transition-colors whitespace-nowrap cursor-pointer">
                無料デモ
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;